import React from 'react'
import { Portal } from 'react-portal'
import { useCallback, useEffect, useRef } from 'sb-hooks'
import actions from 'redux/actions'
import { connect } from 'redaction'

import QueueWidget from 'components/queueNonSubscribed/QueueWidget/QueueWidget'


const QueueWidgetConductor = ({ isOpen, isNotSubscribed, pathname }) => {

  const handleClose = useCallback(() => {
    actions.view.queueWidget.close()
  }, [])

  const isVisible = isOpen && isNotSubscribed

  // Close widget on redirect
  const oldPathname = useRef(null)

  useEffect(() => {
    if (isVisible && oldPathname.current && oldPathname.current !== pathname) {
      handleClose()
    }
    oldPathname.current = pathname

    return () => {
      if (isVisible) {
        handleClose()
      }
    }
  }, [ isVisible, pathname ])

  if (!isVisible) {
    return null
  }

  return (
    <Portal>
      <QueueWidget onClose={handleClose} />
    </Portal>
  )
}


export default connect({
  isOpen: 'view.queueWidget.isOpen',
  isNotSubscribed: 'models.subscription.isNotSubscribed',
  pathname: 'routing.location.pathname',
})(QueueWidgetConductor)
